import { Box, Skeleton, Typography, Paper, Grid } from "@mui/material";

const FormKitPageSkeleton = () => {
    return (
        <Box sx={{ p: 3, backgroundColor: "#822545", height: "100vh" }}>
            <Paper sx={{ p: 3, mb: 3, backgroundColor: "#59162d" }}>
                <Grid container spacing={2}>
                    {/* ID and Date Picker */}
                    <Grid item xs={5}>
                        <Skeleton variant="text" width="100%" height={40} />
                    </Grid>
                    <Grid item xs={5}>
                        <Skeleton variant="text" width="100%" height={40} />
                    </Grid>

                    {/* Metrics Display */}
                    <Grid item xs={1}>

                        <Paper sx={{ p: 2, backgroundColor: "#662235", width: 100, textAlign: "center" }}>
                            <Skeleton variant="text" width="80%" height={30} />
                        </Paper>
                    </Grid>
                    <Grid item xs={1}>

                        <Paper sx={{ p: 2, backgroundColor: "#662235", width: 120, textAlign: "center" }}>
                            <Skeleton variant="text" width="80%" height={30} />
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>

            {/* Table */}
            <Paper sx={{ backgroundColor: "#59162d", padding: 2 }}>
                <Box sx={{ overflowY: "auto", maxHeight: 400 }}>
                    {[...Array(7)].map((_, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                p: 1,
                                backgroundColor: index % 2 === 0 ? "#7a2b45" : "#662235",
                                borderRadius: 1,
                                mb: 1,
                            }}
                        >
                            <Skeleton variant="text" width="10%" height={30} sx={{ marginX: 1 }} />
                            <Skeleton variant="text" width="15%" height={30} sx={{ marginX: 1 }} />
                            <Skeleton variant="text" width="20%" height={30} sx={{ marginX: 1 }} />
                            <Skeleton variant="text" width="15%" height={30} sx={{ marginX: 1 }} />
                            <Skeleton variant="text" width="15%" height={30} sx={{ marginX: 1 }} />
                            <Skeleton variant="circular" width={24} height={24} sx={{ marginX: 1 }} />
                        </Box>
                    ))}
                </Box>
            </Paper>
        </Box>
    );
};

export default FormKitPageSkeleton;